import { useEffect, useMemo, useState } from "react";
import {
  getInvestorCountsForRoles,
  getMostRecentVCDirectoryMetadata,
} from "../services/investorService";
import { InvestorRole } from "../types/ImportedInvestorEntry";
import { VCDirectoryMetadata } from "../types/VCDirectoryMetadata";

export const useInvestorDatabaseMetadata = () => {
  const [isInvestorCountsByRoleLoading, setIsInvestorCountsByRoleLoading] =
    useState(true);
  const [investorCountsByRole, setInvestorCountsByRole] = useState<Map<
    InvestorRole,
    number
  > | null>(null);

  const [isVCDirectoryMetadataLoading, setIsVCDirectoryMetadataLoading] =
    useState(true);
  const [vcDirectoryMetadata, setVCDirectoryMetadata] =
    useState<VCDirectoryMetadata | null>(null);

  useEffect(() => {
    const fetchVCDirectoryMetadata = async () => {
      const metadata = await getMostRecentVCDirectoryMetadata();
      setVCDirectoryMetadata(metadata);
      setIsVCDirectoryMetadataLoading(false);
    };

    const fetchInvestorCountsByRole = async () => {
      const counts = await getInvestorCountsForRoles(
        Object.values(InvestorRole),
      );
      setInvestorCountsByRole(counts);
      setIsInvestorCountsByRoleLoading(false);
    };

    fetchVCDirectoryMetadata();
    fetchInvestorCountsByRole();
  }, []);

  return useMemo(() => {
    // Just make sure we have some mapped investors by role.
    let investorTypeCounts = 0;
    if (investorCountsByRole) {
      for (const count of Array.from(investorCountsByRole.values())) {
        if (count > 0) {
          investorTypeCounts++;
        }
      }
    }

    return {
      hasInvestorTypeCounts: investorTypeCounts > 0,
      vcDirectoryMetadata,
      investorCount: vcDirectoryMetadata?.totalInvestors ?? 0,
      investorCountsByRole,
      isLoading: isVCDirectoryMetadataLoading || isInvestorCountsByRoleLoading,
    };
  }, [
    vcDirectoryMetadata,
    investorCountsByRole,
    isVCDirectoryMetadataLoading,
    isInvestorCountsByRoleLoading,
  ]);
};
